var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"svg-icon icon",domProps:{"innerHTML":_vm._s(require(`assets/icons/${_vm.icon}.svg`))}})
}
var staticRenderFns = []

export { render, staticRenderFns }